import type { SVGProps } from 'react'
const IconProfileOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.84 18.193c0 3.296-4.52 3.677-7.919 3.677h-.243C9.512 21.865 4 21.728 4 18.173c0-3.229 4.338-3.66 7.711-3.676h.453c2.166.005 7.676.141 7.676 3.696m-7.919-2.197c-4.261 0-6.421.732-6.421 2.177 0 1.458 2.16 2.197 6.421 2.197 4.26 0 6.419-.732 6.419-2.177 0-1.458-2.159-2.197-6.419-2.197m0-13.996a5.315 5.315 0 0 1 5.309 5.31 5.314 5.314 0 0 1-5.309 5.309h-.032A5.3 5.3 0 0 1 6.61 7.307 5.316 5.316 0 0 1 11.921 2m0 1.428A3.887 3.887 0 0 0 8.038 7.31a3.873 3.873 0 0 0 3.854 3.882l.029.714v-.714a3.886 3.886 0 0 0 3.881-3.882 3.886 3.886 0 0 0-3.881-3.882"
      clipRule="evenodd"
    />
  </svg>
)
export default IconProfileOutlineIcon
